import styled from "@emotion/styled";
import { theme } from "Styles";

export const Container = styled.div<{ backgroundColour?: string }>`
    background-color: ${({ backgroundColour }) => backgroundColour ?? theme.palette.common.white};
    display: grid;
    grid-template-columns: 35px 1fr 60px;

    @media screen and (max-width: 767px) {
        grid-template-columns: 25px 1fr 40px;
    }

    &:not(:last-of-type) {
        border-bottom: 1px solid ${theme.palette.tableHeader.main};
    }
`;

export const ButtonGroup = styled.div`
    border-left: 1px solid ${theme.palette.tableHeader.main}; // this should be themed.
    padding-top: 5px;
    padding-left: 10px;
    display: flex;
    justify-content: center;
    &.isMobile {
        border-left: none;
        display: flex;
        flex-direction: column-reverse;
        padding: 10px 0px;

        & :last-child {
            margin-bottom: 5px;
        }
    }

    label {
        gap: 0px !important;
    }
    input {
        height: 30px !important;
        width: 30px !important;
    }
`;

export const Reference = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 10px;
    border-right: 1px solid ${theme.palette.tableHeader.main};
`;

export const ReferenceInnerContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 20px 20px;
    justify-content: center;

    label {
        text-align: center;
    }
`;

export const TargetDescription = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    padding: 10px;
    border-bottom: 1px dashed ${theme.palette.tableHeader.main};
    &.isMobile {
        border-bottom: none;
    }
`;

export const Main = styled.div`
    &.isMobile {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        border-bottom: 1px dashed ${theme.palette.tableHeader.main};
    }
`;

export const SessionReportContainer = styled.div<{ backgroundColour?: string }>`
    background-color: ${({ backgroundColour }) => backgroundColour ?? theme.palette.common.white};
    display: block;

    &.isMobile {
        position: relative;
        margin-left: 24px;
        border-left: 1px solid ${theme.palette.tableHeader.main};
        z-index: 1;

        &::after {
            position: absolute;
            height: 100%;
            width: 24px;
            content: "";
            top: 0;
            left: -25px;
            background-color: ${({ backgroundColour }) => backgroundColour ?? theme.palette.common.white};
            z-index: -1;
        }
    }
`;
